/*  src/screens/Dashboard/Overview/widgets/InputFunnelRandsWidget/InputFunnelRandsWidget.tsx  */
import React from 'react';
import {Box, Typography} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import {useSelector} from 'react-redux';

import useDepotStats from '../useDepotStats';
import {RootState} from 'appredux/reducers';

import './InputFunnelRandsWidget.scss';

export default function InputFunnelRandsWidget(): React.ReactElement {
  const {start, end} = useSelector((s: RootState) => s.rdwDateFilter);
  const {loading, stats} = useDepotStats(start, end);

  // Ensure stats is always defined with default values
  const safeStats = stats || {
    quotesTotal: 0,
    invoicesTotal: 0,
    paidInvoicesTotal: 0,
  };

  // Only show skeleton if loading AND no stats available
  if (loading && !stats) {
    return <Skeleton variant="rect" height={140} style={{borderRadius: 8}} />;
  }

  const rows = [
    {label: 'Quotes', value: safeStats.quotesTotal ?? 0},
    {label: 'Orders', value: safeStats.invoicesTotal ?? 0},
    {label: 'Paid orders', value: safeStats.paidInvoicesTotal ?? 0},
  ];

  return (
    <Box className="funnel-widget rands">
      <Typography className="widget-heading">
        INPUT FUNNEL – BY&nbsp;VALUE&nbsp;(R)
      </Typography>

      {rows.map(({label, value}) => (
        <Box key={label} className="funnel-row">
          <Typography className="widget-value">
            R&nbsp;{value.toLocaleString()}
          </Typography>
          <Typography className="row-label">{label}</Typography>
        </Box>
      ))}
    </Box>
  );
}
